<div class="id-photo-input">
    <fa-icon class="status" [icon]="hasValue ? 'check' : 'xmark'"
        [style]="{'color': hasValue ? 'green' : 'red'}"></fa-icon>
    <button type="button" class="toggle-preview cursor-pointer" *ngIf="hasValue" (click)="$event.stopPropagation(); toggleDisplayPreview()">
        {{displayPreview ? '&#x2212;' : '+'}}
    </button>
    <app-big-button class="big_btn big_btn-resp fullWidth"
        [icon]="icon"
        [label]="labelKey | translate"
        [description]="description?.length ? (description | translate) : undefined"
        [selected]="hasValue"
        [responsive]="true"
        (clicked)="openCamera()">
    </app-big-button>
    <div class="preview-box" *ngIf="hasValue">
        <img class="preview" *ngIf="displayPreview" [src]="value" />
    </div>
</div>
<app-webcam *ngIf="showWebcam" [fullHeight]="true" [enableBackUrl]="false" [canRotateCamera]="true"
    [documentCapture]="true" (output)="onCaptured($event)" [includeFaceDetection]="true" runningMode="IMAGE"
    (cameraProblem)="closeCamera()" (back)="closeCamera()"></app-webcam>